import { takeEvery } from 'redux-saga/effects';

import * as profileActions from 'store/modules/profile/actionTypes';

import { updateSubscription } from './utils';

function* listenUpdateSubscription() {
  yield takeEvery(profileActions.UPDATE_SUBSCRIPTION, updateSubscription);
}

export default listenUpdateSubscription;
